import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'

export default (): JSX.Element => {
  const history = useHistory()

  useEffect(() => {
    history.replace('/courses')
  }, [])

  return (
    <>
      <Header />
      <div className={'container'}>
        <LoadingPage />
      </div>
      <Footer />
    </>
  )
}
